import RnIcon from '@/components/icon/icon.vue';
import RnButton from '@/components/button/button.vue';
import { fieldMixin } from '@/mixins';

export default {
	name: 'cs-field-combobox',
	components: {
		RnIcon,
		RnButton,
	},
	mixins: [fieldMixin],
	props: {
		initialValues: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		const options = Array.isArray(this.options) ? this.options : [];
		const initialValues = Array.isArray(this.initialValues) ? this.initialValues.filter(Boolean) : [];

		return {
			isOpen: false,
			searchValue: '',
			values: initialValues.length ? initialValues : options.map(option => option.value),
		};
	},
	computed: {
		selectedCount() {
			return this.values.length;
		},
		visibleSelectedCount() {
			return this.values.length > 9 ? '9+' : this.values.length;
		},
		selectedValueLabel() {
			return this.values.filter(Boolean).join(', ');
		},
		label() {
			return `${this.$t('common.search')} ${this.placeholder
				.split(/(?=[A-Z])/)
				.join(' ')
				.toLowerCase()}...`;
		},
		optionsWithSearch() {
			const options = Array.isArray(this.options) ? this.options : [];
			const knownValues = new Set(options.map(option => option.value));
			const customOptions = this.values
				.filter(value => value && value !== this.searchValue && !knownValues.has(value))
				.map(value => ({
					value,
					name: value,
				}));

			return [
				...(this.searchValue
					? [
							{
								value: this.searchValue,
								name: this.searchValue,
							},
					  ]
					: []),
				...customOptions,
				...options,
			];
		},
	},
	watch: {
		searchValue(newValue, oldValue) {
			if (!newValue || newValue === oldValue) {
				return;
			}

			const options = Array.isArray(this.options) ? this.options : [];
			this.values = [newValue, ...options.map(option => option.value)];
		},
	},
	methods: {
		setIsOpen(state) {
			this.isOpen = state;

			if (state) {
				this.$nextTick(() => {
					this.$refs.searchInput.focus();
				});
			}
		},
		clearValue() {
			this.searchValue = '';
		},
		submit() {
			this.$emit('update:value', this.values);
			this.setIsOpen(false);
		},
	},
};
